import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    // Mini header (task-05)
    MINI_HEADER_BACK_LABEL: 'Volver a tipos de nómina',

    // No-access gate state (task-05) — gate de visibilidad, no una autorización verificada por
    // el servidor (la autoridad es el eventual UserPermissionErrorResponse de la mutation de
    // guardado, Task 11), así que la copia nunca afirma que el permiso se validó server-side.
    EMPTY_NO_ACCESS_TITLE: 'No tienes acceso a esta pantalla',
    EMPTY_NO_ACCESS_DESCRIPTION:
      'Editar el paquete de conceptos es una acción de staff de Crehana.',

    // Error state (task-05)
    ERROR_TITLE: 'No pudimos cargar esta pantalla',
    ERROR_RETRY_BUTTON: 'Reintentar',

    // Footer (task-05; task-11 agrega BUTTON_SAVE junto a esta)
    BUTTON_CANCEL: 'Cancelar',

    // Claves de gap-fix (task-05) — la tabla de i18n del plan (§5.2) las omite aunque su propio
    // texto de mapeo de componentes referencia t('EMPTY_CONCEPT_NOT_FOUND_TITLE') para la
    // guardia !payrollType (misma nomenclatura que admin-concept-formula.page.tsx usa para su
    // estado equivalente de "el id no resolvió a nada").
    EMPTY_CONCEPT_NOT_FOUND_TITLE: 'Este tipo de nómina no existe',
    EMPTY_CONCEPT_NOT_FOUND_DESCRIPTION:
      'Puede que haya sido eliminado o que el enlace esté mal formado.',
    EMPTY_CONCEPT_NOT_FOUND_ACTION: 'Volver a tipos de nómina',

    // Tabla del paquete (task-07) — sólo código/nombre/acciones. Tasks 08/09 agregan las
    // claves de sus propias columnas a este mismo objeto.
    COL_CODE: 'Código',
    COL_NAME: 'Nombre',
    COL_ACTIONS: 'Acciones',
    TABLE_TITLE: 'Conceptos del paquete',
    EMPTY_PACKAGE_TITLE: 'Este tipo de nómina aún no tiene conceptos',
    EMPTY_PACKAGE_DESCRIPTION:
      'Agrega conceptos desde el catálogo para que este tipo de nómina calcule.',
    TOOLTIP_REMOVE_CONCEPT: 'Quitar del paquete',

    // Columnas de tipo de asignación / activo (task-08) — AC-4, AC-6.
    COL_ASSIGNMENT_TYPE: 'Tipo de asignación',
    COL_ASSIGNMENT_ACTIVE: 'Asignación activa',
    ASSIGNMENT_TYPE_ALWAYS: 'Siempre',
    ASSIGNMENT_TYPE_ALWAYS_HINT: 'El motor lo calcula para todos.',
    ASSIGNMENT_TYPE_CONDITIONAL: 'Condicional',
    ASSIGNMENT_TYPE_CONDITIONAL_HINT:
      'Sólo si hay una incidencia que lo gatille.',
    ASSIGNMENT_TYPE_OPTIONAL: 'Opcional',
    ASSIGNMENT_TYPE_OPTIONAL_HINT: 'Sólo por captura manual del admin.',

    // Columnas catalogActive/calculates + nota de las dos banderas (task-09) — AC-7, la razón
    // de ser de este ticket. Copy deliberadamente explicativa, no un label terso: es lo que
    // hace legible la regla "hacen falta las dos" a alguien que nunca leyó el schema.
    TWO_FLAGS_TITLE: 'Dos condiciones, no una',
    TWO_FLAGS_BODY:
      'Un concepto se calcula sólo si está activo en el catálogo Y su asignación está activa. Hacen falta las dos.',
    CATALOG_ACTIVE: 'Activo en catálogo',
    CATALOG_INACTIVE: 'Inactivo en catálogo',
    CALC_YES: 'Calcula',
    CALC_NO: 'No calcula',
    CALC_YES_HINT:
      'El concepto está activo en el catálogo y su asignación está activa.',
    CALC_NO_CATALOG_HINT:
      'Está asignado y activo, pero el concepto está inactivo en el catálogo.',
    CALC_NO_ASSIGNMENT_HINT:
      'El concepto está activo en el catálogo, pero esta asignación está inactiva.',
    CALC_NO_BOTH_HINT:
      'El concepto está inactivo en el catálogo y la asignación también.',
    CALC_UNKNOWN_HINT:
      'No pudimos confirmar el estado de este concepto en el catálogo (índice truncado).',
    COL_CATALOG_ACTIVE: 'Activo en catálogo (lectura)',
    COL_CALCULATES: 'Calcula',

    // Picker de conceptos + guardia de truncamiento (task-10) — AC-8, D-4.
    PICKER_LABEL: 'Agregar concepto',
    PICKER_PLACEHOLDER: 'Selecciona conceptos del catálogo',
    PICKER_ADD_BUTTON: 'Agregar',
    // El conteo es explícito porque la fila opera sobre los resultados VISIBLES del buscador, no
    // sobre el catálogo completo: sin el número, "Seleccionar todo" con un filtro activo es
    // ambiguo.
    PICKER_SELECT_ALL_VISIBLE: 'Seleccionar todo ({{count}})',
    PICKER_NO_RESULTS: 'No encontramos conceptos con ese código o nombre',
    CATALOG_TRUNCATED:
      'El catálogo de esta organización supera lo que podemos mostrar aquí. Contacta a soporte antes de seguir agregando conceptos.',

    // Guardado, error del servidor (AC-9) y descarte (task-11).
    BUTTON_SAVE: 'Guardar cambios',
    SAVE_ERROR_TITLE: 'No pudimos guardar el paquete',
    // Copia defensiva para una respuesta sin `data` o una excepción de red — el mismo hueco
    // que `use-save-concept-rule.ts` cubre con esta misma clave (no es un mensaje del backend,
    // el AC-9 "verbatim" aplica a los tres __typename de error, no a esta rama de respaldo).
    SAVE_UNEXPECTED_ERROR: 'No pudimos guardar el paquete. Intenta de nuevo.',
    TOAST_SAVED: 'Paquete de conceptos guardado',
    DISCARD_DIALOG_TITLE: '¿Descartar cambios sin guardar?',
    DISCARD_DIALOG_BODY:
      'Vas a perder los cambios que hiciste en este paquete.',
    DISCARD_DIALOG_CONFIRM: 'Descartar',
  },
};
